// extracted by mini-css-extract-plugin
export var quillEditor = "_ps-1";
export var variable = "_ps-0";